import { render, staticRenderFns } from "./ShowQuestionsPreview.vue?vue&type=template&id=12d2438c"
import script from "./ShowQuestionsPreview.vue?vue&type=script&lang=js"
export * from "./ShowQuestionsPreview.vue?vue&type=script&lang=js"
import style0 from "./ShowQuestionsPreview.vue?vue&type=style&index=0&id=12d2438c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports